import React, { useEffect, useState } from 'react';
import SelectSACModal from '../../../../components/modals/SeriveModals/AddServicesModals/SelectSACModal';
import SelectCategoryModal from '../../../../components/modals/SeriveModals/AddServicesModals/SelectCategoryModal';
import Popup1 from '../../../../components/modals/SeriveModals/AddServicesModals/Popup1';
import { GetandCreateLinkUnit, GetSpecifiedLinkUnit } from '../../../../services/ProductService/UnitSettings/UnitSettings';
import { GetAndCreateAddProducts } from '../../../../services/ProductService/AddProducts/AddProducts';
import { AllProductsPagination } from '../../../../services/ProductService/AllProductList/AllProductServices';

const ServiceDetails = React.memo(({ serviceDetailsdata, setServiceDetailsData, SelectedProductImages, SelectedCertificatesImages}) => {

  const [productname, setProductName] = useState('');
  const [presentProductId, setPresentProductId] = useState('');
  const [unit, setUnit] = useState('');
  const [otherunits, setOtherAllowedUnits] = useState('');
  const [minOrderQuantityUnit, setMinOrderQuantityUnit] = useState('');
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedCertificates, setSelectedCertificates] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');

  // ✅ Sync unit and minOrderQuantityUnit to state
  const dfltUnit = (unit, otherUnits) => {
    setUnit(unit)
    setOtherAllowedUnits(otherUnits)
    if (unit) {
      setServiceDetailsData({
        ...serviceDetailsdata,
        default_unit: unit
      });
    }
  }

  const handleSelectedDefaultUnit = (unit) => {
    if (unit) {
      setServiceDetailsData({
        ...serviceDetailsdata,
        default_unit: unit
      });
    }
  }

  const minOrderQtyUnt = (unit) => {
    setMinOrderQuantityUnit(unit)
    if (unit) {
      setServiceDetailsData({
        ...serviceDetailsdata,
        min_order_quantity_unit: unit
      });
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceDetailsData({ ...serviceDetailsdata, [name]: value });
  };

  const handleNameChange = (e) => {
    setProductName(e.target.value)
    setServiceDetailsData({ ...serviceDetailsdata, name: e.target.value });
  }

  const handleImageChange = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles.length) {
      const updatedImages = [...selectedImages, ...newFiles];
      setSelectedImages(updatedImages);
      SelectedProductImages(updatedImages)
  
      const fileNames = updatedImages.map(file => file.name);
      setServiceDetailsData({ ...serviceDetailsdata, p_image_id: fileNames });
    }
  };
  
  const handleCertificateChange = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles.length) {
      const updatedCertificates = [...selectedCertificates, ...newFiles];
      setSelectedCertificates(updatedCertificates);
      SelectedCertificatesImages(updatedCertificates);
  
      const fileNames = updatedCertificates.map(file => file.name);
      setServiceDetailsData({ ...serviceDetailsdata, attached_product_certificate: fileNames });
    }
  };
  
  const removeImage = (index) => {
    const updatedImages = selectedImages.filter((_, i) => i !== index);
    setSelectedImages(updatedImages);
    SelectedProductImages(updatedImages)
  
    const fileNames = updatedImages.map(file => file.name);
    setServiceDetailsData({ ...serviceDetailsdata, p_image_id: fileNames });
  };
  
  const removeCertificate = (index) => {
    const updatedCertificates = selectedCertificates.filter((_, i) => i !== index);
    setSelectedCertificates(updatedCertificates);
    SelectedCertificatesImages(updatedCertificates);
  
    const fileNames = updatedCertificates.map(file => file.name);
    setServiceDetailsData({ ...serviceDetailsdata, attached_product_certificate: fileNames });
  };  

  const handleCheck = async (SelectedHSN) => {
    setServiceDetailsData({ ...serviceDetailsdata, p_hsn_code: SelectedHSN.id })
    const response = await GetandCreateLinkUnit('GET', {})
    const spicifiedLinkHSN = response.data.find((item) => item.hsn_code_display === SelectedHSN.code)
    const defaultUnit = spicifiedLinkHSN.default_unit_display
    const o_units = spicifiedLinkHSN.o_allowed_unit
    dfltUnit(defaultUnit, o_units)
    minOrderQtyUnt(defaultUnit)
  }

  const getProductdata = async () => {
    // const response = await GetAndCreateAddProducts('GET', {})
    // const pagecount = response.data.total_pages
    // if (pagecount) {
    //   const params = { page: pagecount }
    //   const response = await AllProductsPagination('GET', { params })
    //   const datas = response.data.results
    //   const lastproductId = datas.at(-1).p_id;
    //   const textPart = lastproductId.replace(/\d+$/, ""); // Removes trailing numbers -> "product"
    //   const numberPart = parseInt(lastproductId.match(/\d+$/), 10); // Extracts numbers -> 21
    //   const incrementedStr = `${textPart}${numberPart + 1}`;
    //   // setPresentProductId(incrementedStr)
    //   setPresentProductId('SER0001')
    // }
  }

  useEffect(() => {
    getProductdata()
  }, [])

  return (
    <div className="grid grid-cols-2 gap-6 mx-10">
      <div className="flex flex-col">
        <label htmlFor="productId" className="font-semibold text-[#667085]">
          Product ID
        </label>
        <input
          id="productId"
          name="p_id"
          value={serviceDetailsdata.p_id || presentProductId}
          placeholder='Enter Product Id.....'
          type="text"
          className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
          disabled
        />
      </div>

      <div className="flex flex-col">
        <label htmlFor="productName" className="font-semibold text-[#667085]">
          Product Name
        </label>
        <input
          id="productName"
          name="name"
          value={serviceDetailsdata.name || ''}
          onChange={handleNameChange}
          placeholder='Enter Product name.....'
          type="text"
          className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
        />
      </div>

      {/* HSN Code Select */}
      {/* <SelectSACModal SelectedHSN={handleCheck} AllDatas={serviceDetailsdata}/> */}

      <div className="flex flex-col">
        <label htmlFor="CategoryOfProduct" className="font-semibold text-[#667085]">
          Category Of Product
        </label>
        <div className="flex w-full space-x-2 items-center">
          <input
            id="CategoryOfProduct"
            name="category_p"
            value={serviceDetailsdata.category_p || selectedCategory || ''}
            onClick={() => setIsModalOpen2(true)}
            type="text"
            placeholder='Enter Category Of the Product.....'
            className="flex-1 p-2 border border-gray-300 rounded-md outline-sky-300"
          />
        </div>
      </div>
      <div>
        <Popup1 name="Default Unit" setValue={unit} otherAllowedUnits={otherunits} setSelectedValue={handleSelectedDefaultUnit} />
      </div>
      {/* Other form fields */}
      <div className="flex flex-col">
        <label htmlFor="indicativePriceRange" className="font-semibold text-[#667085]">
          Indicative Price Range
        </label>
        <div className="flex items-center gap-4 w-full mt-2">
          <input
            id="minPrice"
            name="indicative_min_price"
            value={serviceDetailsdata.indicative_min_price}
            onChange={handleChange}
            type="text"
            placeholder='Enter Minimum Price.....'
            className="flex-1 p-2 border border-gray-300 rounded-md outline-sky-300"
          />
          <span className="text-[#667085]">-</span>
          <input
            id="maxPrice"
            name="indicative_max_price"
            value={serviceDetailsdata.indicative_max_price}
            onChange={handleChange}
            type="text"
            placeholder='Enter Maximum Price.....'
            className="flex-1 p-2 border border-gray-300 rounded-md outline-sky-300"
          />
        </div>
      </div>
      <div className="flex flex-col">
        <label htmlFor="ProductPrice" className="font-semibold text-[#667085]">
          Product Price
        </label>
        <input
          id="ProductPrice"
          name="p_price"
          value={serviceDetailsdata.p_price}
          onChange={handleChange}
          type="number"
          placeholder='Enter Minimum order qty.....'
          className="mt-2 p-2 border border-gray-300 rounded-md  outline-sky-300"
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="ProductOldPrice" className="font-semibold text-[#667085]">
          Product Old Price
        </label>
        <input
          id="ProductOldPrice"
          name="p_old_price"
          value={serviceDetailsdata.p_old_price}
          onChange={handleChange}
          type="number"
          placeholder='Enter Minimum order qty.....'
          className="mt-2 p-2 border border-gray-300 rounded-md  outline-sky-300"
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="ProductDiscount" className="font-semibold text-[#667085]">
          Product Discount
        </label>
        <input
          id="ProductDiscount"
          name="p_discount"
          value={serviceDetailsdata.p_discount}
          onChange={handleChange}
          type="number"
          placeholder='Enter Minimum order qty.....'
          className="mt-2 p-2 border border-gray-300 rounded-md  outline-sky-300"
        />
      </div>
      {/* Product Images Input */}
      <div className="flex flex-col">
        <label htmlFor="productImages" className="font-semibold text-[#667085]">
          Product Images
        </label>
        <input
          id="productImages"
          name="p_image_id"
          // value={serviceDetailsdata.p_image_id}
          onChange={handleImageChange}
          type="file"
          multiple
          className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
        />

        {/* Preview Selected Images */}
        <div className="flex flex-wrap gap-2 mt-4">
          {selectedImages.map((image, index) => (
            <div key={index} className="relative w-24 h-24">
              <span className="text-sm truncate">{image.name}</span>
              <button
                type="button"
                onClick={() => removeImage(index)}
                className="absolute top-0 right-0 bg-red-500 text-white text-xs px-2 py-1 rounded-full"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col">
        <label htmlFor="productionCapacity" className="font-semibold text-[#667085]">
          Production Capacity
        </label>
        <div className="flex w-full mt-2 space-x-2">
          <input
            id="ProductionCapacity"
            name="production_capacity"
            value={serviceDetailsdata.production_capacity}
            onChange={handleChange}
            type="text"
            placeholder='Enter Production Capacity.....'
            className="flex-1 p-2 border border-gray-300 rounded-md outline-sky-300"
          />
          <span className="bg-[#0C92CC] text-gray-400 px-3 py-2 rounded-[5px]">
            <select
              name='production_capacity_unit'
              value={serviceDetailsdata.production_capacity_unit || 'kg'} // ✅ Show 'kg' as default
              onChange={handleChange}
              className="bg-[#0C92CC] text-white px-2 py-1 rounded-[5px] border-none outline-none"
            >
              <option value="kg">kg</option>
              <option value="litre">litre</option>
              <option value="meter">meter</option>  
            </select>
          </span>
        </div>
      </div>

      <div className="flex flex-col">
        <label htmlFor="stockStatus" className="font-semibold text-[#667085]">
          Present Stock Status
        </label>
        <select
          id="stockStatus"
          name="present_stock_status"
          value={serviceDetailsdata.present_stock_status}
          onChange={handleChange}
          required
          className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
        >
          <option name="present_stock_status" value="">Select Present Stock Status</option>
          <option name="present_stock_status" value="in_stock">In Stock</option>
          <option name="present_stock_status" value="produced_on_order">Produced On Order</option>
        </select>
      </div>

      <div className="flex flex-col">
        <label htmlFor="productLeadsTime" className="font-semibold text-[#667085]">
          Production Leads Time In Days
        </label>
        <input
          id="productLeadsTime"
          name="production_lead_time"
          value={serviceDetailsdata.production_lead_time}
          onChange={handleChange}
          type="number"
          placeholder='Enter Production Leads.....'
          className="mt-2 p-2 border border-gray-300 rounded-md  outline-sky-300"
        />
      </div>
      <div className="flex flex-col">
        <label htmlFor="MinimumOrderQuantity" className="font-semibold text-[#667085]">
          Minimum Order Quantity
        </label>
        <input
          id="MinimumOrderQuantity"
          name="min_order_quantity"
          value={serviceDetailsdata.min_order_quantity}
          onChange={handleChange}
          type="text"
          placeholder='Enter Minimum order qty.....'
          className="mt-2 p-2 border border-gray-300 rounded-md  outline-sky-300"
        />
      </div>
      {/* Attach Product Certificate */}
      <div className="flex flex-col">
        <label htmlFor="productCertificate" className="font-semibold text-[#667085]">
          Attach Product Certificate
        </label>
        <input
          id="productCertificate"
          name="p_certificate"
          onChange={handleCertificateChange}
          type="file"
          multiple
          className="mt-2 p-2 border border-gray-300 rounded-md  outline-sky-300"
        />

        {/* Show Selected Certificates */}
        <div className="mt-4">
          {selectedCertificates.map((certificate, index) => (
            <div key={index} className="flex items-center gap-2 bg-gray-100 p-2 rounded-md outline-sky-300">
              <span className="text-sm truncate">{certificate.name}</span>
              <button
                type="button"
                onClick={() => removeCertificate(index)}
                className="bg-red-500 text-white text-xs px-2 py-1 rounded-full"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      </div>

      {isModalOpen2 &&
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="w-full h-full flex items-center justify-center">

            <SelectCategoryModal
              Category={selectedCategory}
              onClose={() => setIsModalOpen2(false)}
              selectedCategory={(selectedItem) => {
                setServiceDetailsData({ ...serviceDetailsdata, category_p: selectedItem });
                setSelectedCategory(selectedItem)
              }}
            />
          </div>
        </div>
      }
    </div>
  );
});

export default ServiceDetails;
